<script lang="ts">
    import { cn } from "@/lib/utils";
    import { tagVariants, type Tag } from "./ActivityTag";
    import { bootstrapTooltip } from '@/Bootstrap';

    type $$Props = Tag & {class?: string}
    let className: $$Props["class"] = undefined
    export {className as class}
    export let label: $$Props["label"]
    export let variant: $$Props["variant"] = "default"
    export let size: $$Props["size"] = "default"
    export let faIcons: $$Props["faIcons"] = null
    export let faIconTypes: $$Props["faIconTypes"]= null
    export let tooltip: $$Props["tooltip"]= null

    
</script>

<div class={cn(tagVariants({variant, size, className}))}
    use:bootstrapTooltip={{
        title: tooltip,
    }}
>
    {#if faIcons}
        {#each {length: faIcons.length} as _, i (faIcons[i])}
            <i class={cn(faIcons[i], faIconTypes[i], label ? "mr-1" : '')} />
        {/each}
    {/if}
    {label}
</div>